<script setup>
defineProps({
  fieldModel: Object,
  disabled: Boolean
})
</script>

<template>
  <textarea
    v-model="fieldModel.inputValue"
    :disabled="disabled || !fieldModel.editable"
    :class="{ 'is-invalid': fieldModel.hasErrors }"
  >
  </textarea>
</template>
